import { ReactNode } from 'react'

interface SectionProps {
  children: ReactNode,
}

interface FormHeaderProps {
  title: string,
  description?: string,
}

export const PageContainer = ({ children }: SectionProps): JSX.Element => (
  <div className='bg-white min-h-screen'>{children}</div>
)

export const HeaderSection = ({ children }: SectionProps): JSX.Element => (
  <div className='px-[54px] py-[32px] flex justify-between border-b border-black sticky top-0 bg-white'>
    {children}
  </div>
)

export const ContentSection = ({ children }: SectionProps): JSX.Element => (
  <div className='px-[54px] py-[32px]'>{children}</div>
)

export const FormSection = ({ children }: SectionProps): JSX.Element => (
  <div className='border-b border-black pb-6 pt-8 gap-2'>{children}</div>
)

export const FormHeader = ({ title, description }: FormHeaderProps): JSX.Element => (
  <div>
    <h2 className="text-2xl font-medium mb-1">{title}</h2>
    {description && <p className="text-sm mb-4">{description}</p>}
  </div>
)
